export const BasicMembershipFormName = 'basic-membership';

export enum BasicMembershipFormFields {
  ProductType = 'productType',
}
